function e(e, r) {
  if (null == e) return {};

  var t,
      n,
      o = function (e, r) {
    if (null == e) return {};
    var t,
        n,
        o = {},
        l = Object.keys(e);

    for (n = 0; n < l.length; n++) {
      t = l[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
    }

    return o;
  }(e, r);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (n = 0; n < l.length; n++) {
      t = l[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
    }
  }

  return o;
}

export { e as _ };